import React, { useState, useEffect } from "react";
import { Grid, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { DatePickerInput } from "rc-datepicker";
import 'rc-datepicker/lib/style.css';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import Modal_Frame from "../biztran_controls/Modal_Frame";
import moment from "moment";
import UseFetchData from "../../hooks/UseFetchData";
import BiztranControls from "../biztran_controls/BiztranControls";
import Data_Grid from "../biztran_controls/DataGrid";
import AddExpenseSheet from "../ExpenseSheet/AddExpenseSheet";
import ApproveTravelRequest from "../Approvels/ApproveTravelRequest"
import EditTravelRequest from "./EditTravelRequest";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import TravelRequestReport from "../crm/Reports/TravelRequestReport";
import ApproveExpense from "../Approvels/ApproveExpense";
import EditExpense from "./EditExpense";


import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@mui/material/Checkbox";
import Button from '@mui/material/Button';
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Session from "react-session-api";
//import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
//import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
//import { IconButton } from "@material-ui/core";
const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/04/01';

const shoppingItems1 = [
    {
        No: 1,
        EmpName: "Akhil",
        Status: "Bilster Machine",
        FromDate: "12456",
        ToDate: "Additional info for Item 1",
        TravelFrom: "Construction Steel",
        TravelTo: "11/Jun/2023",
        Purpose: "15/Jun/2023",
        Amt: ""
    },
    {
        No: 2,
        EmpName: "Amal",
        Status: "Bilster Machine",
        FromDate: "12456",
        ToDate: "Additional info for Item 1",
        TravelFrom: "Construction Steel",
        TravelTo: "11/Jun/2023",
        Purpose: "15/Jun/2023",
        Amt: ""
    },
    // Add more items here
];



const TravelRequest = () => {
    //const classes = useStyles();
    const [FromDate, setFromDate] = useState(fromdate);
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [isOpen, setOpen] = useState(false);
    const [isOpenExpense, setOpenExpense] = useState(false);
    const [rows, setRows] = useState([]);
    const [TravelRequestID, setTravelRequestID] = useState('');
    const [columns, setColumns] = useState([]);
    const [Count, setCount] = useState();
    const [Employee, setEmployee] = useState('');
    const [Manager, setManager] = useState('');
    const [TravelLocation, setTravelLocation] = useState('');
    const [Status, setStatus] = useState('');
    const [ExpenseID, setExpenseID] = useState('');
    const [response, fetchData] = UseFetchData();
    const [shoppingItems1, setShoppingItems] = useState([]);


    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }


    const handleOpenModal = () => {
        setExpenseID('');
        setOpen(true);
    };

    const openModal = (status) => {
        if (status == "TR Rejected" || status == "TR Requested") {
            setOpen(true);
        } else {
            setOpenExpense(true);
        }
    }

    const Statuscmb = [

        { id: "TR Approved", title: "TR Approved" },
        { id: "TR Rejected", title: "TR Rejected" },
        { id: "Travelling", title: "Travelling" },
        { id: "Exp Approved", title: "Exp Approved" },
        { id: "Exp Rejected", title: "Exp Rejected" },
        { id: "ACC Approved", title: "ACC Approved" },
        { id: "ACC Paid", title: "ACC Paid" },

    ];



    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ marginLeft: '93%' }}>
                <GridToolbarExport csvOptions={{
                    fields: ['TravelRequestNo', 'TravelRequestDate', 'EmpCode', 'EmpName', 'Locationto']
                }} />
            </GridToolbarContainer>
        );
    }

    const PopulateData = () => {
        debugger;
        console.log("Hi");
        var bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", "");
        bodyFormData.append("EmpID", Session.get("UID"));
        bodyFormData.append("CategoryID", Session.get("CategoryID"));
        bodyFormData.append("PageName", 'TravelList');
        fetchData("ExpMangt/TravelRequestListWeb", bodyFormData)
    };


    useEffect(() => {
        // Assuming 'response' contains your API response data
        debugger;
        console.log("responseeeeee: ", response);

        if (Array.isArray(response)) {
            // Map the response data to the 'shoppingItems' format
            const newShoppingItems = response.map((item) => ({
                id: item.TravelRequestID,
                No: item.TravelRequestNo, // Adjust this based on your API response
                EmpName: item.EmpName,
                Status: item.ApprovalStatus,
                FromDate: item.FromDate,
                ToDate: item.ToDate,
                TravelFrom: item.LocationFromTravel,
                TravelTo: item.LocationToTravel,
                Purpose: item.PurposeOfTravel,
                Amt: item.ApproxExpAmount
                // Add other properties as needed
            }));

            // Update the 'shoppingItems' state with the mapped data
            setShoppingItems(newShoppingItems);
        }
    }, [response]);




    useEffect(() => {
        PopulateData();
        //setStatus("ACC Approved")
    }, [])

    return (
        <div>
            <Paper elevation={0}>
                <BiztranControls.Button
                    text="Add Request"
                    // startIcon={<SearchIcon />}
                    // style={{ marginTop: '10%' }}
                    onClick={() => {
                        setOpen(true);

                        setTravelRequestID('')
                        // setStatus('')
                        // openModal('')
                    }}
                />
                <Grid container spacing={2}>
                    {shoppingItems1.map((item) => (

                        <Grid key={item.id} item xs={12} sm={12} md={4} lg={4}>
                            <Card style={{ border: '1px solid #e0e0e0' }}>
                                <CardContent>
                                    <b>TR.No : </b>{item.No}
                                    <span style={{ marginLeft: '20px' }}></span>
                                    <b>Status: </b>
                                    <span style={{ fontWeight: 'bold', color: item.Status === 'Travelling' || item.Status == 'TR Approved' ? '#00903D' : '#001B71' }}>
                                        {item.Status}
                                    </span>
                                    <Typography variant="body2" marginTop={1}>
                                        <b>Employee Name : </b> {item.EmpName}
                                    </Typography>
                                    <Typography variant="body2" marginTop={1}>
                                        <b>From Date : </b> {item.FromDate != null ? moment(item.FromDate).format("DD/MMM/YYYY") : ""}
                                        <span style={{ marginLeft: '20px' }}></span>
                                        <b>To Date: </b> {item.ToDate != null ? moment(item.ToDate).format("DD/MMM/YYYY") : ""}
                                    </Typography>
                                    <Typography variant="body2" marginTop={1}>
                                        <b>Travel From : </b> {item.TravelFrom}
                                        <span style={{ marginLeft: '20px' }}></span>
                                        <b>Travel To : </b> {item.TravelTo}
                                    </Typography>
                                    <Typography variant="body2" marginTop={1}>
                                        <b>Purpose of Travel : </b> {item.Purpose}
                                    </Typography>
                                    <Typography variant="body2" marginTop={1}>
                                        <b>Approx Amt : </b> {item.Amt}
                                    </Typography>
                                    <BiztranControls.Button
                                        text="View"
                                        // startIcon={<SearchIcon />}
                                        // style={{ marginTop: '10%' }}
                                        onClick={() => {
                                            //setOpen(true);

                                            setTravelRequestID(item.id)
                                            setStatus(item.Status)
                                            openModal(item.Status)
                                        }}
                                    />
                                </CardContent>
                            </Card>

                        </Grid>
                    ))}
                </Grid>





                <Modal_Frame
                    title="Add/Edit Travel Request"
                    maxWidth="sm"
                    isOpen={isOpen}
                    setOpen={setOpen}
                >
                    <EditTravelRequest
                        TravelRequestID={TravelRequestID}
                        setOpen={setOpen}
                        PopulateData={PopulateData}
                        Status={Status} // <-- Pass Status prop
                    />
                </Modal_Frame>

                <Modal_Frame
                    title="Add/Edit Travel Request"
                    maxWidth="sm"
                    isOpen={isOpenExpense}
                    setOpen={setOpenExpense}
                >
                    <EditExpense
                        TravelRequestID={TravelRequestID}
                        setOpen={setOpenExpense}
                        PopulateData={PopulateData}
                        Status={Status} // <-- Pass Status prop
                    />
                </Modal_Frame>


            </Paper>
        </div>
    )
}

export default TravelRequest;